// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"345127aa","268":"761f82bf","612":"052d5dea","787":"4dca9f0c"}[chunkId] + ".chunk.js";
};